import { attempt, get, isError } from 'lodash';
import { useCallback, useContext } from 'react';
import { UserContext } from '~/providers';
import { UseUserContextResponse } from './types';

export const useUserContext = (): UseUserContextResponse => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUserContext must be used within an UserContextProvider');
    }
    return context;
};

export const useUserFlags = () => {
    const KEY = 'USER_FLAGS';
    const setFlag = useCallback((values: object) => {
        const session = sessionStorage.getItem(KEY);
        const userFlags = session ? attempt(JSON.parse, session) : {};

        if (isError(userFlags)) {
            console.error('Error parsing JSON from session storage');
            return;
        }

        const updatedFlags = { ...userFlags, ...values };

        sessionStorage.setItem(KEY, JSON.stringify(updatedFlags));
    }, []);

    const getFlag = useCallback((flagKey: string) => {
        const session = sessionStorage.getItem(KEY);

        const userFlags = session ? attempt(JSON.parse, session) : {};

        if (isError(userFlags)) {
            console.error('Error parsing JSON from session storage');
            return undefined;
        }

        const flag = get(userFlags, flagKey);
        if (!flag) return undefined;

        return flag;
    }, []);

    return {
        setFlag,
        getFlag,
    };
};
